import { createGetAsyncSlice } from '@sonar-software/xuder';
import { ErrorOrFailStatusCode } from '@sonar-software/sonar-http';
import { getConversationChunks, GetConversationChunksRequest } from '@api';

export const getCoreAgentConversationChunksSlice = createGetAsyncSlice({
	name: 'coreAgentConversationChunks',
	receive: true,
	request: true,
	// xuder only reports a rejected fetch globally, which would leave this slice requested with no Retry.
	requestHandler: (request: GetConversationChunksRequest) => getConversationChunks(request).catch(() => ({
		headers: new Headers(),
		status: ErrorOrFailStatusCode.RequestTimeout
	}))
});
